<script setup lang="ts">
/**
 * Icon-only button. Single-root <button> so title/aria/disabled/@click(.stop) fall through.
 * Consolidates the w-7/w-8/w-9 icon-button drift. Pass the icon via the default slot.
 * `tone`: default (gray) · active (emerald) · danger (red).
 */
interface Props {
  size?: 'sm' | 'md' | 'lg'
  tone?: 'default' | 'active' | 'danger'
}
const props = withDefaults(defineProps<Props>(), { size: 'md', tone: 'default' })

const sizeClass = { sm: 'h-7 w-7', md: 'h-8 w-8', lg: 'h-9 w-9' }
const toneClass = {
  default: 'text-gray-500 hover:bg-gray-200 hover:text-gray-700',
  active: 'text-primary-600 bg-primary-100',
  danger: 'text-danger-600 hover:bg-danger-50 hover:text-danger-700',
}
</script>

<template>
  <button
    type="button"
    class="inline-flex items-center justify-center rounded-md transition-colors hover:cursor-pointer disabled:cursor-default disabled:opacity-50 disabled:hover:bg-transparent"
    :class="[sizeClass[props.size], toneClass[props.tone]]"
  >
    <slot />
  </button>
</template>
